// extracted by mini-css-extract-plugin
export default {"cvError":"C--z"};